import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import OptionGroup from '../../../models/OptionGroup';
import ArticleOption from '../../../models/ArticleOption';
import { DisplayIdentifier } from '../../enums/DisplayIdentifier';
import Article from '../../../models/Article';
import { PreorderType } from '../../../enums/PreorderType';

@Component({
	selector: 'app-article-option-group-flavor',
	templateUrl: './article-option-group-flavor.component.html',
	styleUrls: ['article-option-group-flavor.component.scss'],
})
export class ArticleOptionGroupFlavorComponent implements OnInit {
	@Input() optionGroup: OptionGroup;
	@Input() selected: ArticleOption[];
	@Input() article: Article;
	@Output() selection = new EventEmitter<ArticleOption>();
	@Input() preorderType: PreorderType;

	options: ArticleOption[] = [];
	di = DisplayIdentifier;

	constructor() {}

	ngOnInit() {
		for (const article of this.optionGroup.articles) {
			const articleOption = new ArticleOption();
			articleOption.article = article;
			articleOption.group = this.optionGroup._id;
			articleOption.quantity = 1;
			this.options.push(articleOption);
		}
	}

	onSelectionChange(article: Article) {
		const articleOption = new ArticleOption();
		articleOption.article = article;
		articleOption.group = this.optionGroup._id;
		articleOption.quantity = 1;
		this.selection.emit(articleOption);
	}

	count(article: Article) {
		return this.selected
			.filter(selected => selected.group === this.optionGroup._id && selected.article._id === article._id)
			.map(value => value.quantity)
			.reduce((previousValue, currentValue) => previousValue + currentValue, 0);
	}
}
